import * as actions from './actions';
import * as getters from './getters';
import {FETCH_CURRENT_USER, FORCE_LOGOUT, RESET_CURRENT_USER, SET_TOKEN} from '../../mutation-types'

const mutations = {
  [FETCH_CURRENT_USER](state, payload) {
    state.currentUser = payload
  },
  [FORCE_LOGOUT](state, payload) {
    state.isLoggedIn = payload
  },
  [RESET_CURRENT_USER](state) {
    state.currentUser = null
  },
  [SET_TOKEN](state, payload) {
    state.passwordToken = payload
  }
};

const state = {
  currentUser: JSON.parse(localStorage.getItem('user') )|| null,
  loginUrl: '/auth/user/login',
  registerUrl: '/auth/user/register',
  sendResetMailUrl: '/auth/user/send-reset-mail',
  checkResetTokenUrl: '/auth/user/check-reset-token',
  resetUrl: '/auth/user/reset',
  updatePasswordUrl: '/v1/user/password',
  checkUserUrl: 'v1/user',
  token: localStorage.getItem('token') || null,
  passwordToken: null,
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
